import React from "react";

const LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_3a15dfbd-13c3-4b91-87ee-e64580a64c42/artifacts/6s5vso3k_logo-klus-led.png";

export function Logo({ className = "h-8", withStudio = true }) {
  return (
    <div className="flex items-center gap-2" data-testid="klus-logo">
      <img src={LOGO} alt="KLUS LED" className={className} />
      {withStudio && (
        <span className="hidden sm:inline text-xs font-mono uppercase tracking-widest text-slate-400 border-l border-slate-700 pl-2">
          AI Lighting Studio
        </span>
      )}
    </div>
  );
}
